import { render, staticRenderFns } from "./sendTestCardConfirm.vue?vue&type=template&id=5d854bbb&scoped=true"
import script from "./sendTestCardConfirm.vue?vue&type=script&lang=js"
export * from "./sendTestCardConfirm.vue?vue&type=script&lang=js"
import style0 from "./sendTestCardConfirm.vue?vue&type=style&index=0&id=5d854bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d854bbb",
  null
  
)

export default component.exports